/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./commons-import');
/*const hash=require('object-hash');

window.Vue = require('vue');*/

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
 import {FractionComponent} from 'base-exercise';
 import GoogleAutoAd from '@i/commons/GoogleAutoAd';

const files = require.context('./games/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

Vue.prototype.restrictKeys = function(ev) {
	// console.log(ev);
	if(ev.keyCode == 38 || ev.keyCodev == 40){
		ev.preventDefault();
	}
};



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {
    	loaded: false,
        currentQuiz: {},
    },
    components: { GoogleAutoAd },
    mounted(){
    	this.$loading();
    	this.loaded = true;
    }
});

const article = new Vue({
    el: "#article",
    data: {},
    components: { FractionComponent, GoogleAutoAd },
});

const introduction = new Vue({
    el:"#introduction",
    data:{},
});


// require('./nav-login');